import AppContext from '@services/Context';
import TicketService from '@services/TicketEvent';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import { Button, DatePicker, Input, Select } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import React, { Component } from 'react';
import styled from 'styled-components';

import returnRangeCombo from './ChartTypes/Range';

const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor()
const ticketService: TicketService = new TicketService();


interface IDashboarChartsState {

  processes: any,
  selectedProcess: string,
  components: any
  selectedComponent: string,
  periodType: any,
  minRange: any,
  maxRange: any,
  fromDate: any,
  toDate: any,
  hasRange: boolean,
  readyForChart: boolean,
  data: any,
  localeStoredInfo?: any
  gotProcess: boolean
}


export default class DashboardCharts extends Component<any, IDashboarChartsState> {
  constructor(props: any) {
    super(props)
    this.state = {
      processes: [],
      selectedProcess: '',
      components: '',
      selectedComponent: '',
      periodType: 'year',
      minRange: '',
      maxRange: '',
      fromDate: '',
      toDate: '',
      hasRange: false,
      readyForChart: false,
      data: [],
      gotProcess: false
    }
  }


  componentDidMount = async () => {
    this.getProcesses()
    if (localStorage.getItem('localeStoredInfo') && localStorage.getItem('localeStoredInfo') != null) {
      const localeStoredInfo = JSON.parse(localStorage.getItem('localeStoredInfo') || '')
      localeStoredInfo.readyForChart = true
      localeStoredInfo.hasRange = true
      this.setState(localeStoredInfo)


      await this.getChartInfo()
    }
  }

  getProcesses = async () => {
    const data: any = await _formflowService.paging({
      unit: this.props.unit,
      to: undefined,
      from: undefined,
      limit: 100,
    }, ['id', 'name', 'paths']);


    if(localStorage.getItem('localeStoredInfo') && localStorage.getItem('localeStoredInfo') != null){
      this.setProcess(this.state.selectedComponent.id)
    }
    this.setState({ processes: data, gotProcess: true })
  }

  setProcess = async (value: any) => {
    let selectedProcess = ''
    for (let process of this.state.processes.items) {
      if (process.id === value) {
        selectedProcess = process
      }
    }
    if (this.state.processes) {
      //this part of the code here is a bit tricky
      //i was having trouble on forcing the second select to change to a null value
      //when i changed the first, but i made the render of the second component to render based on the
      //existance of the selectedProcess state
      //so everytime i do this, i kill the second select component and create a brand new one
      this.setState({ selectedProcess: undefined })
    }
    this.setState({ selectedProcess, selectedComponent: '', components: selectedProcess.paths, readyForChart: false })
  }

  setComponent = async (value: string) => {
    this.setState({ selectedComponent: value })
  }

  setPeriod = async (value: string) => {
    this.setState({ periodType: value })
  }

  emptyValuePopper = (dataArray: any) => {
    let cleanArray = dataArray

    cleanArray.find(e => e.values.length > 0)

    return cleanArray
  }

  getChartInfo = async () => {

    let data: any = ''

    this.state.toDate ? data = await ticketService.getProcessComponent(this.state.selectedProcess.id, this.state.selectedComponent, { unit: this.props.unit, from: this.state.fromDate, to: this.state.toDate }) :
      data = await ticketService.getProcessComponent(this.state.selectedProcess.id, this.state.selectedComponent, { unit: this.props.unit, from: this.state.fromDate })
    const localeStoredInfo = {
      selectedProcess: this.state.selectedProcess,
      selectedComponent: this.state.selectedComponent,
      from: this.state.fromDate,
      to: this.state.toDate,
      minRange: this.state.minRange,
      maxRange: this.state.maxRange,
      periodType: this.state.periodType
    }

    data = await this.emptyValuePopper(data)
    
    localStorage.setItem('localeStoredInfo', JSON.stringify(localeStoredInfo))
    this.setState({ selectedProcess: localeStoredInfo.selectedProcess, selectedComponent: localeStoredInfo.selectedComponent, periodType: localeStoredInfo.periodType })
    this.setState({ components: this.state.selectedProcess.paths })
    this.setState({ readyForChart: false })
    this.setState({ data, readyForChart: true })

  }

  returnYearOptions = () => {
    let date: any = new Date();
    date = date.getFullYear()
    const yearArray = []
    for (let i = 2000; i < date; i++) {
      yearArray.push(i)
    }

    return yearArray
  }

  returnDateNumbers = (initialValue: number, maxValue: number) => {
    const yearArray = []
    for (let i = initialValue; initialValue < maxValue; i++) {
      yearArray.push(i)
    }
  }

  setFromDate = async (date: any, dateString: any) => {
    this.setState({ fromDate: date._d.getTime() })
  }

  setTodate = async (date: any, dateString: any) => {
    this.setState({ toDate: date._d.getTime() })
  }

  handleMinInput = (event: any) => {
    if (parseInt(this.state.maxRange) && parseInt(this.state.maxRange) < parseInt(event.target.value)) {
      event.target.value = ''
      NotificationComponent.Notify('error', I18n.l('api.DEFAULT_ERROR'), I18n.l('dashboard.custo.chart.rangeIncosistency'))
    } else {
      this.setState({ minRange: event.target.value })
    }
  }

  handleMaxInput = (event: any) => {
    this.setState({ maxRange: event.target.value, readyForChart: false })
  }

  hasRangeValidator = () => {
    const { minRange, maxRange } = this.state
    if (parseInt(minRange) && parseInt(maxRange)) {
      if (parseInt(minRange) > parseInt(maxRange)) {
        NotificationComponent.Notify('error', I18n.l('api.DEFAULT_ERROR'), I18n.l('dashboard.custo.chart.rangeIncosistency'))
      } else {
        this.setState({ hasRange: true })
      }
    }
  }

  render() {
    
    const { Option } = Select;
    const init = JSON.parse(localStorage.getItem('localeStoredInfo'))
    return (
      <Wrapper>
        <h2 className="title">{this.props.title}</h2>
        <p className="dashboard-text">{I18n.l("dashboard.custom.chart.selectProcess")}</p>
        <Select defaultValue={init ? init.selectedProcess.id : undefined} className="input" placeholder={I18n.l('common.processName')} onChange={this.setProcess}>
          {this.state.processes && this.state.processes.items &&

          this.state.processes.items.map((process: any) => <Option key={process.id} value={process.id}>{process.name}</Option>)

          }
        </Select>
        {(this.state.selectedProcess) &&
          <Select defaultValue={this.state.selectedComponent} className="input" placeholder={I18n.l('common.componentName')} onChange={this.setComponent}>
            {this.state.selectedProcess && this.state.components &&
              this.state.components.map(path => <Option key={path.key} value={path.key}>{path.value}</Option>)
            }
          </Select>}
        {this.state.selectedProcess && this.state.selectedComponent &&
          <div>
            <p className="dashboard-text">{I18n.l("dashboard.custom.chart.rangeSelector")}</p>
            <Input onChange={this.handleMinInput} className="input" placeholder={I18n.l("common.value")} defaultValue={this.state.minRange} />
            <Input onChange={this.handleMaxInput} className="input" placeholder={I18n.l("common.value")} defaultValue={this.state.maxRange} />
            <Button onClick={this.hasRangeValidator}>OK</Button>
          </div>
        }
        {this.state.hasRange &&
          <div className="margin-left-bottom">
            <p className="text">{I18n.l("dashboard.custom.chart.dateSelector")}</p>
            <div className="flex-from-to">
              <span className="text">{I18n.l('common.from')}</span>
              <AppContext.Consumer>
                {({ locale }) => (
                  <>
                    <DatePicker
                      format={I18n.l('common.dateFormat')}
                      locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                      defaultValue={(init && init.fromDate !== '') ? moment(init.fromDate) : undefined}
                      onChange={this.setFromDate}
                    />
                    <span className="text">{I18n.l('common.to')}</span>
                    <DatePicker
                      format={I18n.l('common.dateFormat')}
                      locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                      defaultValue={(init && init.toDate !== '') ? moment(init.toDate) : undefined}
                      onChange={this.setTodate}
                    />
                  </>
                )}
              </AppContext.Consumer>
            </div>
            <div className="flex-from-to">
              <span className="text">{I18n.l('dashboard.display.period.type')}</span>
              <Select style={{ width: '200px' }} onChange={this.setPeriod} defaultValue={this.state.periodType}>
                <Option value={"year"}>{I18n.l('auditconf.goalsyears')}</Option>
                <Option value={"month"}>{I18n.l('auditconf.goalsmonth')}</Option>
              </Select>
            </div>
            <Button onClick={this.getChartInfo}>{I18n.l("dashboard.button.generate")}</Button>
          </div>
        }
        {this.state.readyForChart && this.state.data.length > 0 && returnRangeCombo({ stateData: this.state.data, title: this.props.title, minRange: this.state.minRange, maxRange: this.state.maxRange, period: this.state.periodType })}
        {this.state.readyForChart && this.state.data.length === 0 &&
          <div>
            <h1>{I18n.l('titles.noDataToShow')}</h1>
          </div>
        }
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
.translated-text{
  text-align: center;
  align-self: center;
  transform: translateX(-200px) translateY(-40px);
}

.doughnut-container{
  margin-top: 50px;
  height: 400px;
  width: 500px;
}

.donut-size{
  height: 300px;
  width: 300px;
}

.donut-generator-container{
  display: flex;
  height: 100%;
  width: 100%;
}

.info-text{
  font-size: 1em;
}

.percentage-text{
  font-size: 2em;
  font-weight: 600;
}

.title{
  font-weight: bold;
  margin: 50px 0;
}

.input{
  width: 300px ;
  margin: 20px 10px 20px 0;
}

.dashboard-text{
  width: 300px;
  letter-spacing: 1px;
}

.flex-from-to{
  display: flex;
  width: 600px;
  justify-content: space-between;
  align-items: flex-end;
  margin: 30px 0;
  
  .text{
    align-self: center;
    font-size: 1.2em;
    color: rgba(0,0,0, 0.6);
  }
}
.margin-left-bottom{
  margin-left: 15px;
  margin-bottom: 30px;
}
`
